/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, organizationName: NonNullable<unknown> }} Dry_Mild_Panda_GulpInputs */

const en_dry_mild_panda_gulp = /** @type {(inputs: Dry_Mild_Panda_GulpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} - User - ${i?.organizationName} | Kultify`)
};

const de_dry_mild_panda_gulp = /** @type {(inputs: Dry_Mild_Panda_GulpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} - Benutzer - ${i?.organizationName} | Kultify`)
};

/**
* | output |
* | --- |
* | "{name} - User - {organizationName} \| Kultify" |
*
* @param {Dry_Mild_Panda_GulpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dry_mild_panda_gulp = /** @type {((inputs: Dry_Mild_Panda_GulpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dry_Mild_Panda_GulpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dry_mild_panda_gulp(inputs)
	return de_dry_mild_panda_gulp(inputs)
});